<script setup lang="ts">
import {themeParamsBackgroundColor} from "@telegram-apps/sdk";

useHead({
  title: 'MetalMusicMadness'
});

const authLoading = useState<boolean>('authLoading', () => true)
const sanctumUser = useSanctumUser<ApiToken>()
const showSettings = useState<boolean>('showSettings', () => false)
const bgColor = themeParamsBackgroundColor()

const settings = ref<Settings>({
  streaming: [
    {
      name: 'Bandcamp',
      key: 'bandcamp',
      value: false
    },
    {
      name: 'Spotify',
      key: 'spotify',
      value: false
    },
    {
      name: 'Apple Music',
      key: 'apple',
      value: false
    },
    {
      name: 'Yandex Music',
      key: 'yandex',
      value: false
    }
  ]
})

watch(authLoading, () => {
  setBackRoute('/', true)
  return navigateTo('/')
})

const version = ref<string>('')

onMounted(() => {
  let config = useRuntimeConfig()

  version.value = config.public.version
})
</script>

<template>
  <v-layout class="rounded d-flex flex-column min-h-screen">
    <v-main class="d-flex align-center justify-center my-2 flex-grow-1">
      <v-card class="flex-fill mx-2">
        <v-progress-linear indeterminate v-if="authLoading"/>
        <div v-else-if="!sanctumUser" class="text-grey-lighten-1 pa-2">
          Доступ закрыт. Пожалуйста, проверьте подписку на <a class="text-grey-lighten-1"
                                                              href="https://t.me/mmmvideoblog">паблик
          MetalMusicMadness</a> и, если подписаны, попробуйте зайти в приложение через пару минут.
        </div>
        <div v-else>
          <NuxtPage/>
          <q-dialog v-model="showSettings" backdrop-filter="blur(5px) brightness(50%)" position="top">
            <q-card class="text-grey-lighten-1" :style="{background: bgColor}">
              <q-card-section class="column">
                <q-toggle
                    v-for="setting in settings.streaming"
                    :key="setting.key"
                    v-model="setting.value"
                    :label="setting.name"
                    checked-icon="check"
                    unchecked-icon="clear"
                />
              </q-card-section>
            </q-card>
          </q-dialog>
        </div>
      </v-card>
    </v-main>

    <v-footer class="d-flex align-center justify-center transparent">
      <span class="text-grey-lighten-1">MetalMusicMadness Bot {{ version }} &copy; 2025</span>
    </v-footer>
  </v-layout>
</template>

<style scoped>

</style>